module.exports = __webpack_public_path__ + "static/media/29BDOS22.8587f60a.jpg";